const OUTBOUND_VISIT_KEY = 'shopsmt_outbound_visit';
const DISMISSED_KEY = 'shopsmt_return_cta_dismissed';

/** @type {Set<(productUrl: string) => void>} */
const subscribers = new Set();
let listenerAttached = false;

function readJson(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null || raw === '') {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeJson(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* sessionStorage unavailable */
  }
}

/**
 * @returns {{ productUrl: string, leftAt: number } | null}
 */
function readOutboundVisit() {
  const data = readJson(OUTBOUND_VISIT_KEY);
  if (
    data == null
    || typeof data.productUrl !== 'string'
    || data.productUrl.trim() === ''
    || typeof data.leftAt !== 'number'
  ) {
    return null;
  }

  return {
    productUrl: data.productUrl.trim(),
    leftAt: data.leftAt,
  };
}

/**
 * @returns {Set<string>}
 */
function readDismissedUrls() {
  const data = readJson(DISMISSED_KEY);
  if (!Array.isArray(data)) {
    return new Set();
  }

  return new Set(
    data.filter((url) => typeof url === 'string' && url.trim() !== ''),
  );
}

function writeDismissedUrls(urls) {
  writeJson(DISMISSED_KEY, [...urls]);
}

function notifySubscribers() {
  const visit = readOutboundVisit();
  if (visit == null) {
    return;
  }

  if (readDismissedUrls().has(visit.productUrl)) {
    return;
  }

  for (const callback of subscribers) {
    callback(visit.productUrl);
  }
}

function attachVisibilityListener() {
  if (listenerAttached || typeof document === 'undefined') {
    return;
  }

  listenerAttached = true;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      notifySubscribers();
    }
  });
}

/**
 * @param {(productUrl: string) => void} callback
 * @returns {() => void}
 */
export function subscribeReturnCta(callback) {
  attachVisibilityListener();
  subscribers.add(callback);
  return () => {
    subscribers.delete(callback);
  };
}

/**
 * @param {string} productUrl
 */
export function markProductOutboundVisit(productUrl) {
  const url = typeof productUrl === 'string' ? productUrl.trim() : '';
  if (url === '') {
    return;
  }

  writeJson(OUTBOUND_VISIT_KEY, {
    productUrl: url,
    leftAt: Date.now(),
  });
}

/**
 * @param {string} productUrl
 */
export function dismissProductReturnCta(productUrl) {
  const url = typeof productUrl === 'string' ? productUrl.trim() : '';
  if (url === '') {
    return;
  }

  const dismissed = readDismissedUrls();
  dismissed.add(url);
  writeDismissedUrls(dismissed);
}

/**
 * @param {string} productUrl
 * @returns {boolean}
 */
export function shouldShowReturnCtaForProduct(productUrl) {
  const url = typeof productUrl === 'string' ? productUrl.trim() : '';
  if (url === '') {
    return false;
  }

  const visit = readOutboundVisit();
  if (visit == null || visit.productUrl !== url) {
    return false;
  }

  if (readDismissedUrls().has(url)) {
    return false;
  }

  return true;
}
